export const Links = {
  facebook: 'https://www.facebook.com/share/1B6t8M4RvN/',
  instagram: 'https://www.instagram.com/cabana_bratei/',
  tiktok: 'https://www.tiktok.com/@cabana.bratei',
  whatsapp: 'https://wa.me/+40733745952'
};
